export const INVALID_INPUT_VALUE_ERROR_MESSAGE =
  'Informe um CPF ou CNPJ válido.';
export const MUTATION_ERROR_MESSAGE =
  'Esse número de documento não é o mesmo cadastrado no pedido que você quer alterar.';
